import { AsyncPipe, DatePipe } from '@angular/common'
import { Component, EventEmitter, OnDestroy, Output } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { DialogActionsComponent, KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { CellTemplateDirective, ColumnComponent, DataBindingDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { State } from '@progress/kendo-data-query'
import * as crypto from 'crypto-js'
import { Observable, Subscription } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { MiddleService } from './middle.service'
@Component({
  selector: 'gd-dialog-history-alert',
  template: `
    <kendo-dialog
      title="Alert History"
      (close)="close()"
      [width]="900"
      [maxHeight]="'80%'"
    >
      <kendo-grid
        [kendoGridBinding]="gridData | async"
        [resizable]="true"
        [filterable]="false"
        [sortable]="true"
        [sort]="state.sort"
        [selectable]="false"
      >
        <kendo-grid-column
          field="alertText"
          title="Alert Text"
        ></kendo-grid-column>
        <kendo-grid-column
          field="fromEmail"
          title="From Email"
        ></kendo-grid-column>
        <kendo-grid-column field="dateTimeSent" title="Date Sent">
          <ng-template kendoGridCellTemplate let-column>
            {{ column.dateTimeSent | date : 'MM/dd/yyyy  hh:mm tt' }}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
      <kendo-dialog-actions>
        <button type="button" kendoButton (click)="close()" [primary]="true">
          Close
        </button>
      </kendo-dialog-actions>
    </kendo-dialog>
  `,
  imports: [
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS, KENDO_BUTTONS,
    DataBindingDirective,
    ColumnComponent,
    CellTemplateDirective,
    DialogActionsComponent,
    ButtonComponent,
    AsyncPipe,
    DatePipe,
  ]
})
export class AlertHistoryComponent implements OnDestroy {
  @Output() closeEmitter = new EventEmitter()
  private subscription: Subscription = new Subscription()
  public gridValuesHistory: any[] = []
  public gridValus: any[] = []
  public gridData: Observable<any[]>
  public testGridData: any[] = []
  public state: State = {
    filter: {
      logic: 'and',
      filters: [],
    },
    sort: [
      {
        field: 'dateTimeSent',
        dir: 'desc',
      },
    ],
  }

  constructor(private getreq: MiddleService, private route: ActivatedRoute) {
    if (this.route.snapshot.queryParams['Rview']) {
      this.subscription.add(
        this.route.queryParams.subscribe((params) => {
          const getblotterClient = crypto.AES.decrypt(
            params['Rview'],
            `${environment.securepw}`,
          ).toString(crypto.enc.Utf8)
          const param = { blotId: Number(getblotterClient) }
          this.gridData = this.getreq.GetAlertHistory(param)
        }),
      )
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  close() {
    this.closeEmitter.emit()
  }
}
